export default __webpack_public_path__ + "static/media/spot-1080.67ec9466.jpg";